// extracted by mini-css-extract-plugin
export default {"drawerContainer":"_2Sdy3","labelContainer":"_359-9","label":"_3wvbb","labelIcon":"LodVT"};